import { createSwrListStore } from './swr/createSwrListStore';
import { listSpaces } from '../lib/api';

const swr = createSwrListStore({
  name: 'SpacesStore',
  storageKey: 'bookthing-spaces',
  itemsField: 'spaces',
  setters: {
    set: 'setSpaces',
    add: 'addSpace',
    update: 'updateSpace',
    remove: 'removeSpace',
    reset: 'resetSpaces',
  },
  fetcher: async () => {
    const response = await listSpaces();
    return response.spaces || [];
  },
});

export const useSpacesStore = swr.useStore;
export const useSpacesData = swr.useData;
export const fetchSpacesIfStale = swr.fetchIfStale;
